import { ColorVariant } from 'styling/GlobalStyles'
import { Heading2, SmallText } from 'styling/TypographyV2'
import { ComingSoonPanel } from '../Organogram.styled'

export const ComingSoonTab = ({ name }: { name: string }) => {
  return (
    <ComingSoonPanel>
      <Heading2>{name}</Heading2>
      <SmallText colorVariant={ColorVariant.SECONDARY}>
        Coming soon
      </SmallText>
    </ComingSoonPanel>
  )
}
